import './Add.scss'
export const Add = ({ image, text, description }) => {
    return <div className="w-100 p-3 add">
        <div className='add__content' >
            <div className="add__text" >{text}</div>
            <div>{description}</div>
        </div>
        <div className="add__img"><img className="w-100" src={image} /></div>
    </div>
}